import React, { useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { PageMetaType, PageMetaContext } from '@applyboard/ui-utils';
import InitialPropsContext from './InitialPropsContext';
import StoreWrapper from './StoreWrapper';

const PageWrapper = ({ children, store, ...props }: any) => {
  const [pageMeta, setPageMeta] = useState<PageMetaType>({
    title: 'ApplyBoard',
  });

  return (
    <InitialPropsContext.Provider value={props}>
      <PageMetaContext.Provider value={setPageMeta}>
        <HelmetProvider>
          <StoreWrapper store={store}>
            <Helmet defaultTitle="ApplyBoard" titleTemplate="%s | ApplyBoard">
              {pageMeta.title ? <title>{pageMeta.title}</title> : null}
              {pageMeta.description ? (
                <meta name="description" content={pageMeta.description} />
              ) : null}
            </Helmet>
            {children}
          </StoreWrapper>
        </HelmetProvider>
      </PageMetaContext.Provider>
    </InitialPropsContext.Provider>
  );
};

export default PageWrapper;
